import { DEFAULT_COOKIE_AGE_IN_SECONDS } from "../../constants";

/**
 * Verifica se está rodando em ambiente de produção (HTTPS ou domínio que não seja localhost).
 */
const isProduction = (): boolean => window.location.protocol === "https:" || window.location.hostname !== "localhost";

/**
 * Define um cookie com suporte a ambiente de desenvolvimento (sem secure) e produção (com secure).
 * @param name Nome do cookie
 * @param value Valor do cookie
 * @param maxAgeInSeconds Tempo de vida em segundos (default: 3600 segundos)
 */
const setCookie = (name: string, value: string, maxAgeInSeconds?: number): void => {
	const age = maxAgeInSeconds ?? DEFAULT_COOKIE_AGE_IN_SECONDS;
	const secureFlag = isProduction() ? "secure; " : "";

	document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${age}; ${secureFlag} samesite=Strict`;
};

/**
 * Lê um cookie pelo nome.
 * @param name Nome do cookie
 * @returns O valor do cookie ou null se não existir
 */
const getCookie = (name: string): string | null => {
	const cookies = document.cookie.split("; ");
	for (const cookie of cookies) {
		const [key, value] = cookie.split("=");
		if (key === name) {
			return decodeURIComponent(value);
		}
	}
	return null;
};

/**
 * Remove um cookie pelo nome.
 * @param name Nome do cookie
 */
const deleteCookie = (name: string): void => {
	const secureFlag = isProduction() ? "secure; " : "";
	document.cookie = `${name}=; path=/; max-age=0; ${secureFlag} samesite=Strict`;
};

export default { setCookie, getCookie, deleteCookie };
